window.ttx = window.ttx || {};
ttx.utils = {}


const decode = (str) => {
    try {
        return decodeURIComponent(str)
    } catch {
        return str
    }
}
ttx.utils.getPrototype = function (prototype) {
    return (function () {
        function F() { ttx.console.log('getPrototype') }
        F.prototype = prototype;
        return new F();
    })();
};
ttx.utils.isEmpty = function (value) {
    return value == null || value === '';
};

ttx.utils.browser = function () {
    if (!!window.ActiveXObject || 'ActiveXObject' in window)
        return 'IE';
    return null;
};
ttx.utils.isArray = function (arr) {
    if (typeof Array.isArray === 'function') {
        return Array.isArray(arr);
    }

    return Object.prototype.toString.call(arr) === '[object Array]';
};
ttx.utils.isPlainObject = function (obj) {
    if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') {
        return false;
    }

    const hasOwnConstructor = Object.prototype.hasOwnProperty.call(obj, 'constructor');
    const hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && Object.prototype.hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
        return false;
    }

    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    let key;
    for (key in obj) { /**/ }

    return typeof key === 'undefined' || Object.prototype.hasOwnProperty.call(obj, key);
};


ttx.utils.queryString = function (url) {
    this.pathname = '';
    this.query = {};

    this.init = function () {
        if (!url) url = location.search;
        const index1 = url.indexOf('?');
        const index2 = url.indexOf('#');
        if (index1 >= 0) {
            this.pathname = url.substr(0, index1);
            url = index2 < 0 ? url.substr(index1 + 1) : url.substring(index1 + 1, index2);
            if (url.length > 0) {
                url = url.replace(/\+/g, ' ');
                const params = url.split('&');
                for (let i = 0, len = params.length; i < len; i++) {
                    const param = params[i] || ''
                    if (param) {
                        const index = param.indexOf('=')
                        let key = ''
                        let value = ''
                        if (index < 0) {
                            key = decode(param)
                            value = key
                        } else {
                            key = decode(param.substr(0, index))
                            value = decode(param.substr(index + 1))
                        }
                        this.query[key] = value;
                    }
                }
            }
        } else {
            this.pathname = url;
        }
    };

    this.set = function (key, value) {
        this.query[key] = value;
    };

    this.get = function (key) {
        return this.query[key];
    };

    this.del = function (key) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this.query[key];
    };

    this.has = function (key) {
        return this.query[key] != null;
    };

    this.toStr = function () {
        const items = ['?'];
        for (const key in this.query) {
            items.push(encodeURIComponent(key));
            items.push('=');
            items.push(encodeURIComponent(this.query[key]));
            items.push('&');
        }
        if (items.length === 1) {
            return '';
        } else {
            items.splice(items.length - 1, 1);
            return items.join('');
        }
    };

    this.init();
};

ttx.utils.transferQuery = function (query) {
    const queryString = Object.keys(query).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
    }).join('&')
    return queryString ? '?' + queryString : ''
};


ttx.utils.arrayToObj = function (arr) {
    if (!Array.isArray(arr)) return {};
    const result = arr.reduce((obj, item) => {
        // 可选：校验 item 结构，避免报错（增强健壮性）
        if (item && item.key && item.value !== undefined) {
            obj[item.key] = item.value;
        }
        return obj;
    }, {}); // 初始值为空对象
    return result;
};

ttx.utils.extend = function (params) {
    let options; let name; let src; let copy; let copyIsArray; let clone;
    let target = arguments[0];
    let i = 1;
    const length = arguments.length;
    let deep = false;

    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    } else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
        target = {};
    }

    for (; i < length; ++i) {
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) {
            // Extend the base object
            for (name in options) {
                src = target[name];
                copy = options[name];

                // Prevent never-ending loop
                if (target !== copy) {
                    // Recurse if we're merging plain objects or arrays
                    if (deep && copy && (this.isPlainObject(copy) || (copyIsArray = this.isArray(copy)))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && this.isArray(src) ? src : [];
                        } else {
                            clone = src && this.isPlainObject(src) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[name] = this.extend(deep, clone, copy);

                        // Don't bring in undefined values
                    } else if (typeof copy !== 'undefined') {
                        target[name] = copy;
                    }
                }
            }
        }
    }

    // Return the modified object
    return target;
}

ttx.utils.flattenKey = function (obj, key) {
    const nested = obj[key] || {};
    const { [key]: _, ...rest } = obj;
    return { ...rest, ...nested };
}


ttx.utils.getWin = function (type) {
    if (typeof window === 'undefined') {
        return null;
    }

    if (type === 'top') {
        return window.top || window;
    }

    if (type === 'parent') {
        return window.parent || window;
    }

    return window;
};

ttx.utils.getTopContainer = function () {
    if (typeof document === 'undefined') return null;

    // 优先：当前激活 Pane 的 metaRunnerContainer（弹窗/浮层挂载点，切换系统级页签时自动隐藏）。
    // 每个 Pane 有独立的 metaRunnerContainer（position:relative），挂在它下面才能跟随页签切换。
    const activePane = document.querySelector('[data-ttx-tab-active="true"]');
    if (activePane) {
        const runner = activePane.querySelector('.metaRunnerContainer');
        if (runner instanceof HTMLElement) {
            return runner;
        }
    }
    const anyRunner = document.querySelector('.metaRunnerContainer');
    if (anyRunner instanceof HTMLElement) {
        return anyRunner;
    }

    const root = document.getElementById('workbench');
    const poweredByQiankun = typeof window !== 'undefined' && window.__POWERED_BY_QIANKUN__ === true;
    if (poweredByQiankun) {
        if (ttx.micro && typeof ttx.micro.getContainer === 'function') {
            const container = ttx.micro.getContainer();
            if (container instanceof HTMLElement) {
                return container;
            }
        }

        if (root && root.parentElement) {
            return root.parentElement;
        }

        const qiankunWrapper = document.querySelector('[id^="__qiankun_microapp_wrapper_for_"]');
        if (qiankunWrapper instanceof HTMLElement) {
            return qiankunWrapper;
        }
    }

    if (root) return root;
    return document.body || null;
};

/** 安全过滤符号值（参照 cb xssFilter —— 默认直接返回原值，XSS 过滤由 config 控制） */
ttx.utils.translationSymbols = function (text) {
    return text;
};


ttx.utils.reactBatchUpdate = (innerFunc, enableBatch = false) => {
    if (enableBatch) {
        // 使用unstable_batchedUpdates，实现批量setState的目的
        // https://github.com/facebook/react/issues/14259#issuecomment-439702367
        let reactDom = window.ReactDOM
        if (!reactDom) {
            reactDom = require('react-dom')
        }
        return innerFunc();
        // return reactDom.unstable_batchedUpdates(innerFunc)
    } else {
        return innerFunc()
    }
}

ttx.utils.parseCStyle = function (cStyle, throwOnError = false) {
    if (ttx.utils.isEmptyObject(cStyle) || cStyle === '') return {}
    if (typeof cStyle !== 'string') {
        return cStyle || {}
    }
    let result = {}
    try {
        result = JSON.parse(cStyle)
    } catch (error) {
        // 鍚庣缁忓父閰嶉敊鎹㈣绗︼紝灏戜竴涓弽鏂滄潬锛岃繖閲岀粺涓€澶勭悊涓€涓?
        cStyle = cStyle.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
        try {
            result = JSON.parse(cStyle)
        } catch (error) {
            ttx.console.warn('[cb.utils.parseCStyle]: cStyle瑙ｆ瀽閿欒:', error, cStyle) // @notranslate
            if (throwOnError) {
                throw error
            }
            return {}
        }
    }
    if (typeof result !== 'object') return {}
    return result
}
ttx.utils.isEmptyObject = function (e) {
    let t;
    if (typeof e === 'string') { // e如果为字符串，for in对内存消耗很大（虽然里面有return），所以会用到该方法替代
        return !1;
    }
    if (Array.isArray(e)) {
        return e.length === 0;
    }
    for (t in e)
        return !1;
    return !0
}


ttx.utils.requestIdleCallback = function () {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(...arguments);
    } else {
        const [callback] = arguments;
        callback();
    }
}

ttx.utils.requestAnimationFrame = function (callback) {
    setTimeout(() => {
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(callback);
        } else {
            callback();
        }
    }, 0)
}

// 睡眠一段时间，返回 Promise
ttx.utils.sleep = function (ms) {
    var delay = Number(ms) || 0;
    if (delay < 0) delay = 0;
    return new Promise(function (resolve) {
        setTimeout(resolve, delay);
    });
}
// 防抖：只在停止触发一段时间后执行最后一次调用
ttx.utils.debounce = function (fn, wait) {
    var timer = null;
    var delay = Number(wait) || 0;
    return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn && fn.apply(context, args);
        }, delay);
    };
}

// 节流：在指定时间窗口内只允许执行一次
ttx.utils.throttle = function (fn, wait) {
    var timer = null;
    var lastTime = 0;
    var delay = Number(wait) || 0;
    return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        var remaining = delay - (now - lastTime);
        if (remaining <= 0) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            lastTime = now;
            fn && fn.apply(context, args);
            return;
        }
        if (!timer) {
            timer = setTimeout(function () {
                timer = null;
                lastTime = Date.now();
                fn && fn.apply(context, args);
            }, remaining);
        }
    };
}
// 妫€鏌ユ槸鍚﹁繍琛屽湪 PC 绔?iframe 涓?
ttx.utils.isIframe4PC = function () {
    return window.self !== window.top && window.jDiwork;
}

// 瀹夊叏 JSON 瑙ｆ瀽锛屽吋瀹圭┖鍊煎拰瀛楃涓?
ttx.utils.jsonParse = function (str, fallback) {
    if (!str || typeof str !== 'string') return fallback || {};
    try {
        return JSON.parse(str);
    } catch (e) {
        return fallback || {};
    }
}

// 瀛楃涓茶浆 JSON 瀵硅薄锛堝埆鍚嶏紝鍏煎鍘嗗彶璋冪敤锛?
ttx.utils.stringToJSON = function (str) {
    if (!str) return {};
    if (typeof str === 'object') return str;
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
}

// ==================== 环境判断 ====================

/**
 * 是否 iOS 设备
 * @returns {boolean}
 */
ttx.utils.isIos = function () {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

/**
 * 是否 Mac 设备
 * @returns {boolean}
 */
ttx.utils.isMac = function () {
    return /macintosh|mac os x/i.test(navigator.userAgent);
};

/**
 * 是否 IE 浏览器
 * @returns {boolean}
 */
ttx.utils.isIE = function () {
    return !!window.ActiveXObject || 'ActiveXObject' in window;
};

/**
 * 是否老版 Edge 浏览器（新版是 Edg）
 * @returns {boolean}
 */
ttx.utils.isEdge = function () {
    return /edge/i.test(navigator.userAgent);
};

/**
 * 是否是 <%.*%> 型模板数据
 * @param {*} value - 待检测值
 * @returns {boolean}
 */
ttx.utils.isMatchValue = function (value) {
    return typeof value === 'string' && /<%[^%]*%>/g.test(value);
};

// ==================== 数据转换 ====================

/**
 * 转换成 Boolean，支持 '1'/'y'/'true' 字符串
 * @param {*} value - 待转换值
 * @returns {boolean}
 */
ttx.utils.getBooleanValue = function (value) {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;
    if (typeof value === 'string') {
        var v = value.toLowerCase();
        return v === '1' || v === 'y' || v === 'true';
    }
    return !!value;
};

/**
 * 科学计数法转数字
 * @param {number} num - 待转换数值
 * @returns {number|*} 非科学计数法的数字，非数字则返回原值
 */
ttx.utils.getFullNum = function (num) {
    if (typeof num === 'number' && !Number.isNaN(num)) {
        return String(num).includes('e') ? Number(num).toFixed(20).replace(/\.?0+$/, '') : num;
    }
    return num;
};

/**
 * 保留小数位
 * @param {number} value - 数值
 * @param {number} decimal - 小数位数
 * @returns {string} 格式化后的字符串
 */
ttx.utils.getRoundValue = function (value, decimal) {
    var num = Number(value);
    if (isNaN(num)) return value;
    var d = Number(decimal) || 0;
    return num.toFixed(d);
};

/**
 * 浮点数精确运算
 * @example
 * ttx.utils.FloatCalc.add(0.1, 0.2)     // '0.3'
 * ttx.utils.FloatCalc.sub(0.3, 0.1)     // '0.2'
 * ttx.utils.FloatCalc.mult(0.1, 0.2)    // '0.02'
 * ttx.utils.FloatCalc.divide(0.3, 0.1)  // '3'
 */
ttx.utils.FloatCalc = {
    _toInt: function (val) {
        var s = String(Number(val));
        var dotIdx = s.indexOf('.');
        return dotIdx < 0 ? [parseInt(s), 0] : [parseInt(s.replace('.', '')), s.length - dotIdx - 1];
    },
    add: function (val1, val2) {
        var a = ttx.utils.FloatCalc._toInt(val1);
        var b = ttx.utils.FloatCalc._toInt(val2);
        var maxDec = Math.max(a[1], b[1]);
        var pow = Math.pow(10, maxDec);
        return String((Number(val1) * pow + Number(val2) * pow) / pow);
    },
    sub: function (val1, val2) {
        var a = ttx.utils.FloatCalc._toInt(val1);
        var b = ttx.utils.FloatCalc._toInt(val2);
        var maxDec = Math.max(a[1], b[1]);
        var pow = Math.pow(10, maxDec);
        return String((Number(val1) * pow - Number(val2) * pow) / pow);
    },
    mult: function (val1, val2) {
        var a = ttx.utils.FloatCalc._toInt(val1);
        var b = ttx.utils.FloatCalc._toInt(val2);
        var dec = a[1] + b[1];
        return String((a[0] * b[0]) / Math.pow(10, dec));
    },
    divide: function (val1, val2) {
        var a = ttx.utils.FloatCalc._toInt(val1);
        var b = ttx.utils.FloatCalc._toInt(val2);
        return String((a[0] / b[0]) * Math.pow(10, b[1] - a[1]));
    }
};

/**
 * 获取模板值 <%key%>
 * @param {string} formatValue - 模板字符串，如 '<%userName%>'
 * @param {object} [dataSource] - 数据源，默认读取 ttx.rest.AppContext
 * @returns {*} 解析后的值
 */
ttx.utils.getPredicateValue = function (formatValue, dataSource) {
    if (!formatValue) return formatValue;
    if (typeof formatValue !== 'string') return formatValue;
    var match = formatValue.match(/<%([^%]*)%>/);
    if (!match) return formatValue;
    var key = match[1];
    var source = dataSource || (ttx.rest && ttx.rest.AppContext) || {};
    return source[key];
};

/**
 * 删除对象中空值(null/undefined/'')或空对象引用（修改原值）
 * @param {object} obj - 待处理对象
 * @returns {object} 处理后的对象
 */
ttx.utils.removeEmplyAttr = function (obj) {
    if (!obj || typeof obj !== 'object') return obj;
    Object.keys(obj).forEach(function (key) {
        var val = obj[key];
        if (val === null || val === undefined || val === '') {
            delete obj[key];
        } else if (ttx.utils.isEmptyObject(val)) {
            delete obj[key];
        }
    });
    return obj;
};

/**
 * 删除对象或 JSON 字符串中的指定属性
 * @param {object|string} target - 对象或 JSON 字符串
 * @param {string} key - 要删除的属性名
 * @returns {object|string} 处理后的结果，类型与输入一致
 */
ttx.utils.omitAttr = function (target, key) {
    if (typeof target === 'string') {
        try {
            var parsed = JSON.parse(target);
            if (parsed && typeof parsed === 'object') {
                delete parsed[key];
            }
            return JSON.stringify(parsed);
        } catch (e) {
            return target;
        }
    }
    if (target && typeof target === 'object') {
        delete target[key];
        return target;
    }
    return target;
};

// ==================== 工具方法 ====================

/**
 * 对象深对比
 * @param {*} obj1 - 对比对象1
 * @param {*} obj2 - 对比对象2
 * @returns {boolean} 是否相等
 */
ttx.utils.compareObject = function (obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2;
    }
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return false;
        for (var i = 0; i < obj1.length; i++) {
            if (!ttx.utils.compareObject(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (var j = 0; j < keys1.length; j++) {
        var k = keys1[j];
        if (!Object.prototype.hasOwnProperty.call(obj2, k)) return false;
        if (!ttx.utils.compareObject(obj1[k], obj2[k])) return false;
    }
    return true;
};

/**
 * 生成自增长 ID
 * @param {string} [prefix='id'] - ID 前缀
 * @returns {string} 例如 'id_1', 'rowId_2'
 */
ttx.utils._newIdCounter = 0;
ttx.utils.getNewId = function (prefix) {
    ttx.utils._newIdCounter += 1;
    return (prefix || 'id') + '_' + ttx.utils._newIdCounter;
};

/**
 * 生成 GUID
 * @returns {string} 格式如 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
 */
ttx.utils.getNewGuid = function () {
    function s4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

/**
 * URL 拼接参数
 * @param {string} url - 原始 URL
 * @param {object} obj - 参数键值对
 * @returns {string} 拼接后的 URL
 * @example
 * ttx.utils.setQueryString('https://baidu.com?c=0', {aaa: 0, bb: 111})
 * // 'https://baidu.com?c=0&aaa=0&bb=111'
 */
ttx.utils.setQueryString = function (url, obj) {
    if (!url) return '';
    if (!obj || typeof obj !== 'object') return url;
    var parts = [];
    Object.keys(obj).forEach(function (key) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    });
    if (parts.length === 0) return url;
    var connector = url.indexOf('?') >= 0 ? '&' : '?';
    return url + connector + parts.join('&');
};

// 文件上传
ttx.utils.uploadFile = function (options) {
    var opts = options || {};
    var file = opts.data && opts.data.file;
    var businessId = opts.businessId || '';
    var objectName = opts.objectName || '';
    var authId = opts.authId || null;
    var onSuccess = opts.onSuccess || function () {};
    var onError = opts.onError || function () {};
    var onProcess = opts.onProcess || function () {};

    if (!file) {
        onError(null, new Error('缺少文件参数'));
        return;
    }

    var formData = new FormData();
    formData.append('file', file);
    if (businessId) formData.append('businessId', businessId);
    if (objectName) formData.append('objectName', objectName);
    if (authId != null) formData.append('authId', authId);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/attachment/upload', true);
    xhr.withCredentials = true;

    xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
            onProcess({ percent: Math.round((e.loaded / e.total) * 100), loaded: e.loaded, total: e.total });
        }
    };

    xhr.onload = function () {
        if (xhr.status === 200 || xhr.status === 201) {
            try {
                var res = JSON.parse(xhr.responseText);
                if (res.code === 200) {
                    onSuccess(res.data, null);
                } else {
                    onError(null, new Error(res.msg || '上传失败'));
                }
            } catch (e) {
                onError(null, new Error('响应解析失败'));
            }
        } else {
            onError(null, new Error('上传失败: HTTP ' + xhr.status));
        }
    };

    xhr.onerror = function () {
        onError(null, new Error('网络错误'));
    };

    xhr.send(formData);
};

// alert 弹窗
ttx.utils.alert = function (msg, type) {
    if (ttx.modal && ttx.modal.alert) {
        ttx.modal.alert(msg, type);
    } else {
        window.alert(msg);
    }
}

// ==================== MDF 工具方法补充 ====================

/**
 * 数字格式化
 * @param {number|{value:*}} valueObj - 数值或 { value: 数值 } 对象
 * @param {object} [options] - 格式化选项
 * @param {number} [options.decimal] - 小数位数
 * @param {boolean} [options.thousandsSep] - 是否千分位分隔
 * @param {boolean} [options.round] - 是否四舍五入（默认截断）
 * @returns {string} 格式化后的字符串
 */
ttx.utils.decimalFormatter = function (valueObj, options) {
    var opts = options || {};
    var val = (valueObj && typeof valueObj === 'object') ? valueObj.value : valueObj;
    var num = Number(val);
    if (isNaN(num)) return val == null ? '' : String(val);
    var decimal = opts.decimal != null ? Number(opts.decimal) : null;
    // 小数位处理
    if (decimal != null) {
        if (opts.round) {
            num = Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal);
        }
        num = Number(num.toFixed(decimal));
    }
    var str = decimal != null ? num.toFixed(decimal) : String(num);
    // 千分位分隔
    if (opts.thousandsSep) {
        var parts = str.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        str = parts.join('.');
    }
    return str;
};

/**
 * 数组项枚举转换（用户自定义类型枚举值/名互转）
 * @param {Array} list - 待转换数组
 * @param {boolean} bToName - true: 值转名称；false: 名称转值
 * @returns {Array} 转换后的数组（同 list 引用）
 */
ttx.utils.changeUserDefineTypeEnumValue = function (list, bToName) {
    if (!ttx.utils.isArray(list)) return list;
    list.forEach(function (item) {
        if (!item || !item.userDefineType) return;
        var enumMap = item.userDefineType.enumMap || item.userDefineType;
        if (bToName) {
            // 值转名称
            if (enumMap && enumMap[item.value] != null) {
                item.text = enumMap[item.value];
            }
        } else {
            // 名称转值
            if (enumMap) {
                for (var v in enumMap) {
                    if (Object.prototype.hasOwnProperty.call(enumMap, v) && enumMap[v] === item.text) {
                        item.value = v;
                        break;
                    }
                }
            }
        }
    });
    return list;
};

/**
 * 兼容多语对象取值
 * @param {object|string} obj - 多语对象 { zh: '..', en: '..' } 或字符串
 * @param {string} [locale] - 指定语言，默认取当前语言
 * @returns {string} 对应语言的文本
 */
ttx.utils.getLocalValue = function (obj, locale) {
    if (obj == null) return '';
    if (typeof obj !== 'object') return String(obj);
    var lang = locale || (ttx.context && ttx.context.global && ttx.context.global.getLocale && ttx.context.global.getLocale()) || 'zh';
    if (obj[lang] != null) return obj[lang];
    // 兜底：zh → 第一个值
    if (obj.zh != null) return obj.zh;
    var keys = Object.keys(obj);
    return keys.length ? obj[keys[0]] : '';
};

/**
 * 解析 cParameter（容器/控件参数，通常为 JSON 字符串）
 * @param {string|object} cParameter
 * @returns {object} 解析后的对象
 */
ttx.utils.parseCParameter = function (cParameter) {
    if (ttx.utils.isEmptyObject(cParameter) || cParameter === '') return {};
    if (typeof cParameter !== 'string') return cParameter || {};
    try {
        var result = JSON.parse(cParameter);
        return (typeof result === 'object' && result) ? result : {};
    } catch (e) {
        ttx.console.warn('[cb.utils.parseCParameter]: cParameter 解析错误:', e, cParameter);
        return {};
    }
};

// ==================== 获取信息 ====================

/**
 * 获取用户信息（userType: 0-5）
 * @param {string} [domainKey] - 领域编码
 * @returns {object|null} 用户信息
 */
ttx.utils.getUser = function (domainKey) {
    var ctx = ttx.rest && ttx.rest.getAppContext ? ttx.rest.getAppContext(domainKey) : null;
    return (ctx && ctx.user) || null;
};

/**
 * 获取组织 ID
 * @param {string} [domainKey] - 领域编码
 * @returns {string|number|null} 组织 ID
 */
ttx.utils.getOrgId = function (domainKey) {
    var user = ttx.utils.getUser(domainKey);
    return (user && (user.orgId || user.orgid || user.id_org)) || null;
};

/**
 * 获取租户 ID
 * @param {string} [domainKey] - 领域编码
 * @returns {string|number|null} 租户 ID
 */
ttx.utils.getTenantId = function (domainKey) {
    var ctx = ttx.rest && ttx.rest.getAppContext ? ttx.rest.getAppContext(domainKey) : null;
    if (ctx && ctx.tenant) {
        return ctx.tenant.id || ctx.tenant.tenantId || ctx.tenant;
    }
    return (ctx && (ctx.tenantId || ctx.tenantid)) || null;
};

/**
 * 获取交易类型
 * @param {object} viewmodel - ViewModel
 * @returns {string|null} 交易类型
 */
ttx.utils.getTransType = function (viewmodel) {
    if (!viewmodel) return null;
    var params = (typeof viewmodel.getParams === 'function' && viewmodel.getParams()) || {};
    return params.transType || params.transtype || params.busiType || null;
};

/**
 * 获取 token
 * @param {string} [domainKey] - 领域编码
 * @returns {string|null} token
 */
ttx.utils.getToken = function (domainKey) {
    var ctx = ttx.rest && ttx.rest.getAppContext ? ttx.rest.getAppContext(domainKey) : null;
    return (ctx && (ctx.token || ctx.accessToken)) || null;
};

/**
 * 读取 cookie
 * @param {string} name - cookie 名
 * @returns {string|null} cookie 值
 */
ttx.utils.getCookie = function (name) {
    if (!name || typeof document === 'undefined' || !document.cookie) return null;
    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : null;
};

/**
 * 获取当前日期时间，格式 '2021-10-26 14:11:00'
 * @returns {string} 格式化后的日期时间
 */
ttx.utils.getNowFormatDate = function () {
    var d = new Date();
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' '
        + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
};

/**
 * 获取全球化上下文
 * @param {Function} [callback] - 回调，参数为全球化上下文对象
 * @returns {object} 全球化上下文（ttx.context.global）
 */
ttx.utils.getGlobalzition = function (callback) {
    var g = (ttx.context && ttx.context.global) || {};
    if (typeof callback === 'function') {
        try { callback(g); } catch (e) { ttx.console.error('[cb.utils.getGlobalzition]:', e); }
    }
    return g;
};

/**
 * 获取字符串长度（中文字符计 2，其余计 1）
 * @param {string} text - 待统计文本
 * @returns {number} 长度
 */
ttx.utils.getValueLength = function (text) {
    if (text == null) return 0;
    var str = String(text);
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        // 中文字符（含全角符号）计 2
        len += /[\u4e00-\u9fa5\uff00-\uffff]/.test(str.charAt(i)) ? 2 : 1;
    }
    return len;
};

/**
 * 按 serviceCode 获取已注册的 ViewModel
 * @param {string} serviceCode - 服务编码
 * @returns {object|null} ViewModel
 */
ttx.utils.getVmByServiceCode = function (serviceCode) {
    if (!serviceCode || !ttx.debug) return null;
    var vms = ttx.debug.vms || {};
    for (var key in vms) {
        if (Object.prototype.hasOwnProperty.call(vms, key)) {
            var vm = vms[key];
            var sc = (typeof vm.getServiceCode === 'function' && vm.getServiceCode())
                || (vm.getParams && vm.getParams().serviceCode);
            if (sc === serviceCode) return vm;
        }
    }
    return null;
};

/**
 * 获取当前活跃 ViewModel
 * @returns {object|null} 当前活跃 ViewModel
 */
ttx.utils.getActiveVm = function () {
    if (ttx.debug && typeof ttx.debug.getCurrentVM === 'function') {
        return ttx.debug.getCurrentVM();
    }
    return null;
};

/**
 * 获取当前活跃领域编码
 * @returns {string|null} 领域编码
 */
ttx.utils.getActiveDomainKey = function () {
    var vm = ttx.utils.getActiveVm();
    if (vm && typeof vm.getDomainKey === 'function') {
        return vm.getDomainKey();
    }
    return null;
};

/**
 * 按 serviceCode 获取已注册的 ViewModel 列表
 * @param {string} [serviceCode] - 服务编码，不传则返回全部
 * @returns {Array} ViewModel 数组
 */
ttx.utils.getVmListByServiceCode = function (serviceCode) {
    if (!ttx.debug) return [];
    var vms = ttx.debug.vms || {};
    var result = [];
    for (var key in vms) {
        if (Object.prototype.hasOwnProperty.call(vms, key)) {
            var vm = vms[key];
            if (!serviceCode) {
                result.push(vm);
            } else {
                var sc = (typeof vm.getServiceCode === 'function' && vm.getServiceCode())
                    || (vm.getParams && vm.getParams().serviceCode);
                if (sc === serviceCode) result.push(vm);
            }
        }
    }
    return result;
};

/**
 * 默认值变更后的处理（触发视图刷新等）
 * @param {object} viewmodel - ViewModel
 */
ttx.utils.afterDefaultValueChange = function (viewmodel) {
    if (!viewmodel) return;
    // 触发数据刷新事件，由 ViewModel 内部监听处理
    if (typeof viewmodel.execute === 'function') {
        try { viewmodel.execute('afterDefaultValueChange'); } catch (e) { ttx.console.error('[cb.utils.afterDefaultValueChange]:', e); }
    }
};

// ==================== 其它 ====================

/**
 * 播放音频
 * @param {string} url - 音频地址
 * @returns {{promise: Promise, element: HTMLAudioElement, play: Function, pause: Function, stop: Function}}
 */
ttx.utils.playAudio = function (url) {
    var element = new Audio(url);
    element.src = url;
    var promise = element.play();
    return {
        promise: Promise.resolve(promise),
        element: element,
        play: function () { return element.play(); },
        pause: function () { element.pause(); },
        stop: function () { element.pause(); try { element.currentTime = 0; } catch (e) {} }
    };
};

/**
 * 构建请求懒加载 params
 * @param {object} params - 原始参数
 * @param {boolean} [addPageInfo] - 是否追加分页信息
 * @param {string} [name] - 字段名
 * @param {boolean} [isSearch] - 是否搜索
 * @returns {object} 构建后的 params
 */
ttx.utils.buildLazyLoadSimpleVOs = function (params, addPageInfo, name, isSearch) {
    var result = ttx.utils.extend(true, {}, params || {});
    if (addPageInfo) {
        result.page = result.page || { pageIndex: 1, pageSize: 20 };
    }
    if (name) {
        result.simpleVOs = result.simpleVOs || [];
        if (!isSearch) {
            // 追加字段条件
            result.simpleVOs.push({ field: name, op: 'like', value1: result.keyword || '' });
        }
    }
    return result;
};

/**
 * 调用操作日志
 * @param {object} params - 日志参数
 * @param {object} [viewmodel] - ViewModel
 */
ttx.utils.saveOperationLog = function (params, viewmodel) {
    try {
        var domainKey = (viewmodel && typeof viewmodel.getDomainKey === 'function' && viewmodel.getDomainKey()) || params.domainKey;
        if (ttx.rest && ttx.rest.DynamicProxy) {
            var proxy = ttx.rest.DynamicProxy.create({
                saveOperationLog: {
                    url: '/api/operationLog/save',
                    method: 'POST',
                    options: { uniform: false, domainKey: domainKey }
                }
            });
            proxy.saveOperationLog(function (err) {
                if (err) ttx.console.warn('[cb.utils.saveOperationLog]: 保存操作日志失败', err);
            }, params);
        }
    } catch (e) {
        ttx.console.error('[cb.utils.saveOperationLog]:', e);
    }
};

/**
 * 生成 fieldid
 * 表头：[BillNo]|[cItemName]
 * 表体：[BillNo]|[childrenField][cItemName]|[index]
 * @param {object} args - { billNo, cItemName, childrenField, index }
 * @returns {string} fieldid
 */
ttx.utils.getFieldID = function (args) {
    if (!args || !args.billNo || !args.cItemName) return '';
    // 表体：含 childrenField 与 index
    if (args.childrenField != null && args.index != null) {
        return args.billNo + '|' + args.childrenField + args.cItemName + '|' + args.index;
    }
    // 表头
    return args.billNo + '|' + args.cItemName;
};

/**
 * 表格滚动到指定单元格
 * @param {string} childrenfiled - 子表字段名
 * @param {number} rowIndex - 行索引
 * @param {string} [attr] - 列属性
 */
ttx.utils.scrollToTableCell = function (childrenfiled, rowIndex, attr) {
    if (childrenfiled == null || rowIndex == null) return;
    try {
        // 定位单元格 DOM：约定 selector 为 [data-field="..."][data-row="..."]
        var selector = '[data-field="' + childrenfiled + '"][data-row="' + rowIndex + '"]';
        if (attr) selector += '[data-attr="' + attr + '"]';
        var cell = document.querySelector(selector);
        if (cell && typeof cell.scrollIntoView === 'function') {
            cell.scrollIntoView({ block: 'center', inline: 'center', behavior: 'auto' });
        }
    } catch (e) {
        ttx.console.warn('[cb.utils.scrollToTableCell]:', e);
    }
};

/**
 * 特征组值是否变化
 * @param {object} gridModel - 表格模型
 * @param {object} args - 参数 { rowIndex, key, value }
 * @param {string} [sensitiveKey] - 敏感字段名
 * @returns {boolean} 是否变化
 */
ttx.utils.bCharacterChange = function (gridModel, args, sensitiveKey) {
    if (!gridModel || !args) return false;
    try {
        var rowIndex = args.rowIndex != null ? args.rowIndex : args.row;
        var key = args.key || args.cItemName || sensitiveKey;
        var newValue = args.value;
        // 读取旧行数据
        var oldRow = (typeof gridModel.getRow === 'function' && gridModel.getRow(rowIndex))
            || (typeof gridModel.getSelectRow === 'function' && gridModel.getSelectRow());
        var oldValue = oldRow ? oldRow[key] : undefined;
        // 比较是否变化（宽松比较，兼容字符串/数字）
        return String(oldValue) !== String(newValue);
    } catch (e) {
        ttx.console.warn('[cb.utils.bCharacterChange]:', e);
        return false;
    }
};